// Filename: LoginScreenStyles.ts
//
// Component: Login Screen styles
//
// Purpose:
// Provide reusable style classes for the LoginScreen Page
// Page, keeping styling separate from logic and makes UI consistent.
//
// What this file does:
// - Uses MUI's `useTheme()` hook to access theme variables.

import { makeStyles } from "tss-react/mui";

export const useLoginScreenStyles = makeStyles()((theme) => ({
    outerContainer: {
        display: "flex",
        flexDirection: "row",
    },
    homeButtonContainer: {
        position: "absolute",
        left: theme.spacing(2),
        top: theme.spacing(2),
    },
    image: {
        width: "100%",
        height: "100vh",
        objectFit: "cover",
    },
    loginSection: {
        minWidth: "40%",
        minHeight: "100%",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        position: "absolute",
        right: 0,
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing(4),
    },
    logo: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3),
    },
    textFieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    passwordFieldAndForgotPassword: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    },
    forgotPassword: {
        fontSize: "15px",
    },
    buttonAndCreateAccount: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        alignItems: "center",   
    },
    createAccount: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        alignItems: "center",
    }
}));